"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "fields", {
  enumerable: true,
  get: function get() {
    return _fields["default"];
  }
});
Object.defineProperty(exports, "ModelAPI", {
  enumerable: true,
  get: function get() {
    return _api["default"];
  }
});
Object.defineProperty(exports, "ApiFilter", {
  enumerable: true,
  get: function get() {
    return _apiFilter["default"];
  }
});
exports["default"] = void 0;

var _model = _interopRequireDefault(require("./model"));

var _fields = _interopRequireDefault(require("./fields"));

var _api = _interopRequireDefault(require("./api"));

var _apiFilter = _interopRequireDefault(require("./apiFilter"));

/**
 * @module       models/index
 * @description  Entry point to the models module.
 *
 * @author  William Huster <william@thinknimble.com>
 */
var _default = _model["default"];
exports["default"] = _default;